import React, { useState, useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { useTheme } from '../ThemeContext';
import ModelBuilder from './lab/ModelBuilder';
import BacktestEngine from './lab/BacktestEngine';
import CommunityModels from './lab/CommunityModels';
import ModelTemplates from './lab/ModelTemplates';
import { Zap } from 'react-feather';
import './Lab.css';
import '../shared/PageHeader.css';

function Lab() {
  const { user } = useContext(AuthContext);
  const { isDarkMode } = useTheme();
  const [activeTab, setActiveTab] = useState('builder');
  const [currentModel, setCurrentModel] = useState(null);
  const [backtestResults, setBacktestResults] = useState(null);

  const tabs = [
    { id: 'builder', label: 'Model Builder', icon: '🔬' },
    { id: 'templates', label: 'Templates', icon: '📋' },
    { id: 'backtest', label: 'Backtest', icon: '📊' },
    { id: 'community', label: 'Community', icon: '👥' }
  ];

  if (!user) {
    return (
      <div className="lab-container">
        <div className="lab-login-prompt">
          <div className="lab-login-content">
            <div className="lab-login-icon">🔬</div>
            <h2>Welcome to the Prediction Laboratory</h2>
            <p>Build, test, and deploy your own prediction models</p>
            <p className="login-message">Please log in to access the Lab</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="lab-container">
      <div className="top-header-header">
        <div className="top-header-title">
          <Zap className="top-header-icon" />
          <div>
          <h1>Prediction Laboratory</h1>
          </div>
          <span className="top-header-beta">BETA</span>
        </div>
        <p className="top-header-subtitle">
          Build, test, and compete with custom prediction models
        </p>
      </div>

      <div className="lab-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`lab-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="lab-content">
        {activeTab === 'builder' && (
          <ModelBuilder 
            currentModel={currentModel}
            setCurrentModel={setCurrentModel}
            onRunBacktest={(model) => {
              setCurrentModel(model);
              setActiveTab('backtest');
            }}
          />
        )}
        
        {activeTab === 'templates' && (
          <ModelTemplates 
            onSelectTemplate={(template) => {
              setCurrentModel(template);
              setActiveTab('builder');
            }}
          />
        )}
        
        {activeTab === 'backtest' && (
          <BacktestEngine 
            currentModel={currentModel}
            results={backtestResults}
            setResults={setBacktestResults}
          />
        )}
        
        {activeTab === 'community' && (
          <CommunityModels 
            onSelectModel={(model) => {
              setCurrentModel(model);
              setActiveTab('builder');
            }}
          />
        )}
      </div>
    </div>
  );
}

export default Lab;
